var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sections),function(section){return _c('div',{key:section.id},[_c('div',{class:`BgEmotionChartLabels ${
        _vm.currentSection === section.id ? 'active' : ''
      }`,style:({
        left: _vm.getLeft(section.timestamp_start),
      })}),_c('div',{class:`BgEmotionChartLabels--current-section ${
        _vm.currentSection === section.id ? 'active' : ''
      }`,style:({
        left: _vm.getLeft(section.timestamp_start),
        width: _vm.getWidth(section.timestamp_start, section.timestamp_end),
      })}),_c('div',{class:`BgEmotionChartLabels ${
        _vm.currentSection === section.id ? 'active' : ''
      }`,style:({
        left: _vm.getLeft(section.timestamp_end),
      })})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }